export const URL_FETCH_OTP_BY_PHONE = "/v1/auth/otp";
export const URL_VERIFY_OTP_CODE = "/v1/auth/otp/check";
export const URL_REFRESH_TOKENS = "/v1/auth/token/refresh";
export const URL_AUTHORIZE = "/v1/auth/token";
export const URL_PROFILE = "/v1/profile";
export const URL_REGISTER = "/v3/profile/register/magnit-id-code";
export const URL_CHECK_USER_PROFILE = "/v1/keeperid/bunch";
export const URL_EXCHANGE_EXTERNAL_TOKEN = "/v1/auth/cross-token/exchange";
